/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { icpXdrConversionRatesGetApiV3IcpXdrConversionRates } from "../../funcs/icpXdrConversionRatesGetApiV3IcpXdrConversionRates.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3IcpXdrConversionRatesRequest$inboundSchema
    .optional(),
};

export const tool$icpXdrConversionRatesGetApiV3IcpXdrConversionRates:
  ToolDefinition<typeof args> = {
    name: "icp-xdr-conversion-rates-get-api-v3-icp-xdr-conversion-rates",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await icpXdrConversionRatesGetApiV3IcpXdrConversionRates(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
